import { Images } from '@flowus/login/images';
import { ScoreRuleUrl } from '@flowus/login/utils';
import type { FC } from 'react';
import { publicLink } from 'src/common/const';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

interface Props {
  isJoinTeam?: boolean;
  showScoreRule?: boolean;
}
export const LoginFooter: FC<Props> = (props) => {
  const { t } = useAppTranslation();
  if (__PRIVATE__) return null;
  return (
    <div className="my-3 tracking-wide text-center text-t4 h-md:text-t2 text-black">
      {props.showScoreRule && !__BUILD_IN__ ? (
        <div className="flex items-center justify-center w-full">
          <img src={Images.IcInviteInfo} className="w-5 h-5 mr-1" />
          <a className="underline" target="_blank" href={ScoreRuleUrl} rel="noreferrer">
            {t('components.login_uikit.learn_score_rules')}
          </a>
        </div>
      ) : (
        <>
          {t('components.login_uikit.click_action', {
            action: props.isJoinTeam ? t('components.login_uikit.join_team') : t('common.continue'),
          })}
          &nbsp;<span>{t('components.login_uikit.means_you_agree')}</span>&nbsp;
          <a className="underline" target="_blank" href={publicLink.userAgreement} rel="noreferrer">
            {t('common.user_agreement')}
          </a>
          &nbsp;<span>{t('components.login_uikit.and')}</span>&nbsp;
          <a className="underline" target="_blank" href={publicLink.privacyPolicy} rel="noreferrer">
            {t('common.privacy_policy')}
          </a>
        </>
      )}
    </div>
  );
};
